import { FC, useEffect, useRef } from 'react';
import useAudioRecorder from '../../hooks/audio';
import { useSpeaking } from '../../stores/speaking';
import VoiceWaveForm from './VoiceWaveForm';
import { useTranslation } from 'react-i18next';
import RecordIcon from '../../assets/icons/new-record-icon.png';
import PauseIcon from '../../assets/icons/new-pause-icon.png';
import { Image, Text } from '@chakra-ui/react';

export const InputMic: FC<{
  isDisbaled: boolean;
  onDataAvailable: (data: Blob) => void;
}> = ({ isDisbaled, onDataAvailable }) => {
  const { t } = useTranslation();
  const { isListening, startListening, stopListening } =
    useAudioRecorder(onDataAvailable);
  const { setIsSpeaking } = useSpeaking();

  const isInitialized = useRef(false);

  useEffect(() => {
    console.log('isListening', isListening);
    setIsSpeaking(isListening);
  }, [isListening, setIsSpeaking]);

  const handleStartListening = () => {
    if (!isInitialized.current) {
      isInitialized.current = true;
      startListening();
    } else {
    }
  };

  return (
    <div
      className={`w-full h-fit flex flex-col items-center justify-center ${
        isDisbaled ? 'pointer-events-none opacity-50' : ''
      }`}
    >
      {isListening ? (
        <button
          onClick={stopListening}
          className="w-fit h-fit md:hover:scale-105"
        >
          <Text fontWeight="bold" fontSize={{ base: 'sm', md: 'lg' }} mb="3">
            {t('tapToPause')}
          </Text>
          <Image src={PauseIcon} h={{ base: '5rem', md: '7rem' }} />
        </button>
      ) : (
        <button
          onClick={handleStartListening}
          className="w-fit h-fit md:hover:scale-105"
        >
          <Text fontWeight="bold" fontSize={{ base: 'sm', md: 'lg' }} mb="3">
            {t('tapToTalk')}
          </Text>
          <Image src={RecordIcon} h={{ base: '5rem', md: '7rem' }} />
        </button>
      )}
    </div>
  );
};
